import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-15px",
  },
  tabs: {
    backgroundColor: "#fff",
    color: "#000",
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0',
    minHeight: '48px',
    '& .MuiTabs-flexContainer': {
      flexWrap: 'wrap',
      flex: 1,
      justifyContent: 'flex-start',
      display: 'flex',
      gap: '2px',
      rowGap: '4px',
      minWidth: 0,
    },
  },
  tabsWithActions: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '0 4px',
    gap: '8px',
    // Without this, width:100% plus the horizontal padding makes this box 8px
    // wider than its parent, which is what put a horizontal scrollbar on the
    // expanded batch view even when the tab's own table fitted.
    boxSizing: 'border-box',
  },
  tab: {
    minWidth: 'auto',
    padding: '12px 10px',
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    marginTop: "8px",
    position: "relative",
    whiteSpace: 'nowrap',
    textAlign: 'center',
    flexShrink: 0,
    "&::before": {
      content: '""',
      position: "absolute",
      left: '50%',
      transform: 'translateX(-50%)',
      width: 'calc(100% - 12px)',
      height: "4px",
      top: 0,
      background: "linear-gradient(82deg, #3B173F 0%, #073270 100%)",
    },
    "&.Mui-selected": {
      color: "#34a0f7",
    },
  },
  indicator: {
    display: "none",
  },
  tabsRoot: {
    minHeight: '48px',
  },
  uploadButton: {
    backgroundColor: '#ec6535',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '2rem',
    minWidth: '180px',
    height: '40px',
    padding: '8px 20px',
    '&:hover': {
      backgroundColor: '#000000',
      color: '#fff',
    },
  },
  messagesButton: {
    background: 'linear-gradient(82deg, #3B173F 0%, #073270 100%) 0% 0% no-repeat padding-box',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '4px',
    minWidth: '95px',
    height: '36px',
    padding: '8px 16px',
    fontSize: '0.813rem',
    fontWeight: 500,
    '&:hover': {
      background: 'linear-gradient(82deg, #3B173F 0%, #073270 100%) 0% 0% no-repeat padding-box',
      opacity: 0.9,
      color: '#fff',
    },
  },
  viewButton: {
    backgroundColor: 'transparent',
    color: '#666',
    textTransform: 'none',
    borderRadius: '4px',
    minWidth: '80px',
    height: '36px',
    padding: '8px 12px',
    fontSize: '0.813rem',
    fontWeight: 500,
    border: '1px solid #e0e0e0',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      color: '#000',
      borderColor: '#ccc',
    },
  },
  viewButtonActive: {
    backgroundColor: '#ffffff',
    color: '#000000',
    textTransform: 'none',
    borderRadius: '4px',
    minWidth: '80px',
    height: '36px',
    padding: '8px 12px',
    fontSize: '0.813rem',
    fontWeight: 500,
    border: '1px solid #000000',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      color: '#000000',
      borderColor: '#000000',
    },
  },
  chatIconButton: {
    width: '36px',
    height: '36px',
    borderRadius: '4px',
    backgroundColor: '#ffffff',
    border: '1px solid #000000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '& svg': {
      color: '#3B173F',
    },
    '&:hover': {
      backgroundColor: '#f5f5f5',
      borderColor: '#000000',
      '& svg': {
        color: '#3B173F',
      },
    },
  },
  actionButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
  },
  // Batch Genealogy / Download Report — right-aligned action buttons that sit
  // beside the tab bar (per PD Post-Feedback UI Changes, slide 5).
  tabActionButtons: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    alignItems: 'center',
    flexShrink: 0,
    marginLeft: 'auto',
    paddingLeft: '8px',
  },
  batchGenealogyButton: {
    background: 'linear-gradient(82deg, #3B173F 0%, #073270 100%) 0% 0% no-repeat padding-box',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '6px',
    minWidth: '150px',
    height: '38px',
    padding: '8px 18px',
    fontSize: '0.813rem',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    '&:hover': {
      background: 'linear-gradient(82deg, #3B173F 0%, #073270 100%) 0% 0% no-repeat padding-box',
      opacity: 0.92,
      color: '#fff',
    },
    '&.Mui-disabled': {
      background: '#c7c7d1',
      color: '#fff',
    },
  },
  downloadReportButton: {
    backgroundColor: '#ffffff',
    color: '#1A2D6C',
    textTransform: 'none',
    borderRadius: '6px',
    minWidth: '150px',
    height: '38px',
    padding: '8px 18px',
    fontSize: '0.813rem',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    border: '1px solid #1A2D6C',
    '&:hover': {
      backgroundColor: '#f4f6fa',
      color: '#1A2D6C',
      borderColor: '#1A2D6C',
    },
    '&.Mui-disabled': {
      color: '#9aa0b4',
      borderColor: '#d7dbe0',
    },
  },
  headerBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '4px 0',
    marginBottom: '4px',
  },
}));

